module.exports = __webpack_public_path__ + "html/section-company-info_27aa3428de66376bbda3eb25e1896180.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-company-info.html
// module id = JO6v
// module chunks = 66